define([
  'react',
  'underscore',
  'es6!sumo/util',
  'es6!sumo/util/Font',
  'es6!sumo/dom',
], (React, _, Util, FontUtil, DOM) => {
  const { classNames } = Util;
  const { SVGImage } = DOM;

  class Tab extends React.Component {
    constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
    }

    onClick() {
      const { onClick } = this.props;
      if (onClick) onClick();
    }

    renderFontLink() {
      const fontFamily = this.props.style.fontFamily;
      if (!fontFamily || FontUtil.isBrowserFont(fontFamily)) return null;

      return (
        <link
          key={fontFamily}
          href={FontUtil.fullGoogleFontUrlFromFontFamily(fontFamily)}
          rel="stylesheet"
          type="text/css"
        />
      );
    }

    render() {
      const {
        mode,
        showType,
        position,
        style,
        text,
        api,
        size,
        isPreview,
        selectedComponentId,
      } = this.props;

      const className = classNames('sumome-react-form-tab', {
        [`sumome-react-form-tab-${mode}`]: !!mode,
        [`sumome-react-form-tab-${showType}`]: !!showType,
        [`sumome-react-form-tab-${position}`]: !!position,
        [`sumome-react-form-tab-${size}`]: !!size,
        'sumome-react-form-tab-is-preview': isPreview,
        'sumome-react-form-tab-is-selected': selectedComponentId === 'tab' && isPreview,
        'sumome-react-form-tab-is-game': (mode === 'game'),
      });

      const tabStyle = _.extend(style, {
        fill: style.backgroundColor,
      });

      if (mode !== 'game') {
        tabStyle.backgroundColor = 'transparent';
      } else {
        tabStyle.fill = style.color;
      }

      return (
        <div className={className} style={tabStyle} onClick={this.onClick}>
          {this.renderFontLink()}
          <SVGImage
            key={`sumome-tab-${mode}`}
            src={`${api.properties.baseUrl}images/apps/156085c5-0017-4150-b225-a731ad248f38/tab-types/${mode}.svg`}
            preserveAspectRatio="none"
          />
          <span className="sumome-react-form-tab-text">{(mode !== 'game') ? text : ''}</span>
        </div>
      );
    }
  }

  return Tab;
});
